import { createApi } from '@reduxjs/toolkit/query/react';
import type {
    MoreItemsForCombinedShippingApiResponse,
    MoreItemsFromSellerForCombinedShippingApiRequest,
} from 'tradera/state/services/types/webapi-discover-generated';

import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const checkoutUpsellApi = createApi({
    reducerPath: 'checkoutUpsellApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getCombinedShippingFromSeller: builder.query<
            MoreItemsForCombinedShippingApiResponse,
            MoreItemsFromSellerForCombinedShippingApiRequest
        >({
            query: (payload) => ({
                url: '/api/webapi/discover/web/more-items/for-combined-shipping-from-seller',
                method: 'POST',
                body: payload,
            }),
        }),
    }),
});

export const { useGetCombinedShippingFromSellerQuery } = checkoutUpsellApi;
